import { Component } from '@angular/core';

import { ActionSheet, ActionSheetController, Config, NavController, ToastController } from 'ionic-angular';

import { ParplatzData } from '../../providers/pp-data';
import { UECreatePage } from '../ue/ue-create';
import { KontrollenCreatePage } from '../kontrollen/kontrollen-create';
import { PPDetailPage } from '../pp-list/pp-detail';
import { UserData } from '../../providers/user-data';
import { Http, Headers, RequestOptions } from '@angular/http';
import { CommonData } from '../../providers/common-data';
import { Geolocation } from '@ionic-native/geolocation';
import { Platform } from 'ionic-angular';

@Component({
  selector: 'pp-list',
  templateUrl: 'pp-list.html'
})
export class PPListPage {
  actionSheet: ActionSheet;
  pps = [];

  lat:number;
  lng:number;

  

  constructor(  
               public common: CommonData
             , public actionSheetCtrl: ActionSheetController
             , public navCtrl: NavController
             ,  public http: Http
             , public ppData: ParplatzData
             , public config: Config
             , public userData: UserData
             , public platform: Platform
             , private geolocation: Geolocation

             ) {
    this.lat = 47.01341503304151;
    this.lng = 8.30725377426325;
               
    this.pps = ppData.data;
    //this.reorderPPs();
  }
  reorderPPs(){
    if(this.pps){
      //-- distanz berechnen -----
      for(let i=0;i<this.pps.length; i++){
        let dist = this.common.getDistanceFromLatLonInKM(this.lat, this.lng, this.pps[i].latit, this.pps[i].longit);
        this.pps[i].distance = dist;
      }
      this.pps.sort((a: any, b: any) => {
              if (a.distance < b.distance ){
              //a is the Object and args is the orderBy condition (data.likes.count in this case)
                  return -1;
              }else if( a.distance > b.distance ){
                  return 1;
              }else{
                  return 0;
              }
          });
    }
  }

  ionViewDidLoad(){
    this.platform.ready().then(() => {
      this.geolocation.getCurrentPosition({enableHighAccuracy:true}).then((position) => {
        //console.log("PPList view did load:");
        //console.log(position);
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.reorderPPs();
        //let latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        /*
        let mapOptions = {
          center: latLng,
          zoom: 15,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        }
  
        this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
        */
      }, (err) => {
        console.log(err);
      });    
    });    
  }

  openUEUpload(pp) {
//    this.navCtrl.push(UEUploadPage, pp);
    if(!this.common.wifierror){
      if(this.common.actpageviewmode != "pplist"){
        //this.navCtrl.push(UECreatePage, pp);
        //this.navCtrl.push(KontrollenCreatePage, {pp:pp,actlat: this.lat, actlng:this.lng});
        this.navCtrl.setRoot(KontrollenCreatePage, {pp:pp,actlat: this.lat, actlng:this.lng});
      }
      else{

        //this.navCtrl.push(PPDetailPage, pp, { animate: true, animation:'ios-transition', direction: 'forward' });
        this.navCtrl.push(PPDetailPage, pp);
      }

    }
    else{
      this.common.showWifiError(); 
    }
  }





}



// WEBPACK FOOTER //
// ./src/pages/pp-list/pp-list.ts